import gql from 'graphql-tag';

export const USER_CHATS_LITE =  gql`
query($states:[Int]! $limit:Int) {
  chats(states:$states, limit:$limit) {
        id
        idSesion
        waId
        fechaCreacion
        estado{
          id
        }
        tipo{
          id
        }
        nombreProductor
        nombreProfesional
        usuarioProductor
        usuarioProfesional
    }
  }
`;

export const GET_COURSES = gql`
  query Query{
    courses{
      edges {
        node {
          id
          name
          description
          image
        }
      }
    }
  }
`;

export const GET_PROFESSIONAL_HAS_CONTACT_CENTER = gql`
query Query {
  professionalHasContactCenter
}
`;

export const GET_PROFESIONAL_RULES_LITE = gql`
query Query {
  profesionales {
    edges {
      node {
        normas {
          id
          descripcion
          metadata
        }
      }
    }
  }
}
`;